import { render, staticRenderFns } from "./ObjectsActionButtons.vue?vue&type=template&id=e0e27062"
import script from "./ObjectsActionButtons.vue?vue&type=script&lang=ts"
export * from "./ObjectsActionButtons.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports